'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _omit = require('lodash/omit');var _omit2 = _interopRequireDefault(_omit);

var _OMAutocompleteInput = require('../../components/OMComponents/OMAutocompleteInput/OMAutocompleteInput');var _OMAutocompleteInput2 = _interopRequireDefault(_OMAutocompleteInput);

var _constants = require('../../constants');
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _highlightSuggestion = require('../../helpers/highlightSuggestion');var _highlightSuggestion2 = _interopRequireDefault(_highlightSuggestion);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
var ProfessionalsPageSearchInput = function (_Component) {_inherits(ProfessionalsPageSearchInput, _Component);function ProfessionalsPageSearchInput() {var _temp, _this, _ret;_classCallCheck(this, ProfessionalsPageSearchInput);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      suggestions: [],
      value: '' }, _this.





























    onKeyDown = function (event) {
      if (event.keyCode === _constants.enterKey) {
        event.preventDefault();
        _this.setState({
          value: event.target.value });

      }
    }, _this.

    getSuggestionValue = function (suggestion) {return suggestion ? suggestion.address : '';}, _this.

    getInputValue = function (value) {var
      queryName = _this.props.queryName;
      _this.setState({ value: value }, function () {
        if (value.length === 0) {
          var query = Object.assign({},
          _this.props.query || {});

          var modifiedQuery = (0, _omit2.default)(query, [queryName]);

          _this.setState({ suggestions: [] });

          if (_this.props.isRealtorsAssociation) {
            _reactRouter.browserHistory.push({
              pathname: (0, _appendLocale2.default)(_this.props.locale, '/professionals/realtors_association/search'),
              query: modifiedQuery });

          } else if (_this.props.isBrokerCommunity) {
            _reactRouter.browserHistory.push({
              pathname: (0, _appendLocale2.default)(_this.props.locale, '/professionals/broker/search'),
              query: modifiedQuery });

          } else {
            _reactRouter.browserHistory.push({
              pathname: (0, _appendLocale2.default)(_this.props.locale, '/professionals/search'),
              query: modifiedQuery });

          }
        }
      });
      if (value.trim().length > 0) {
        _this.setState({ value: value });
        _this.props.receiveSuggestions({
          query: value,
          type: 'city' });

      }
    }, _this.

    searchSelectedOption = function (value) {var
      queryName = _this.props.queryName;

      var query = Object.assign({},
      _this.props.query || {});


      if (queryName === 'professionals_city') {
        query.professionals_city = value.address;
      }

      if (queryName === 'property_city') {
        query.property_city = value.address;
      }

      if (_this.props.isRealtorsAssociation) {
        _reactRouter.browserHistory.push({
          pathname: (0, _appendLocale2.default)(_this.props.locale, '/professionals/realtors_association/search'),
          query: query });

      } else if (_this.props.isBrokerCommunity) {
        _reactRouter.browserHistory.push({
          pathname: (0, _appendLocale2.default)(_this.props.locale, '/professionals/broker/search'),
          query: query });

      } else {
        _reactRouter.browserHistory.push({
          pathname: (0, _appendLocale2.default)(_this.props.locale, '/professionals/search'),
          query: query });

      }
    }, _temp), _possibleConstructorReturn(_this, _ret);}ProfessionalsPageSearchInput.prototype.componentWillMount = function componentWillMount() {var city = this.props.city;if (city) {this.setState({ value: city });}};ProfessionalsPageSearchInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {var suggestions = _ref.suggestions,city = _ref.city,locale = _ref.locale,address = _ref.address;if (this.props.city !== city && !city) {this.setState({ value: '' });}if (this.props.city !== city && city) {this.setState({ value: city });}if (this.props.suggestions !== suggestions) {var filteredSuggestions = suggestions && suggestions.map(function (item) {return item.tags && item;});this.setState({ suggestions: filteredSuggestions });}if (this.props.address !== address && address && address.length) {var inputValue = address[0].address;this.setState({ value: inputValue });}};ProfessionalsPageSearchInput.prototype.

  render = function render() {
    var searchInputPlaceholder = this.props.placeholder;
    return (
      _react2.default.createElement(_OMAutocompleteInput2.default, {
        inputValue: this.state.value,
        initialValue: this.state.value,
        placeholder: searchInputPlaceholder,
        theme: _constants.inputStyleTheme,
        getInputValue: this.getInputValue,
        suggestions: this.state.suggestions,
        getSuggestionValue: this.getSuggestionValue,
        selectedSuggestion: this.searchSelectedOption,
        shouldRenderSuggestions: function shouldRenderSuggestions() {return true;},
        onKeyDown: function onKeyDown() {},
        deferRequestBy: 300,
        autoFocus: this.state.autoFocus,
        className: this.props.className,
        renderSuggestions: _highlightSuggestion2.default,
        isProfessionals: true,
        isDeferredBlur: true,
        isValid: true }));


  };return ProfessionalsPageSearchInput;}(_react.Component);


ProfessionalsPageSearchInput.propTypes = {
  suggestions: _propTypes2.default.array,
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  city: _propTypes2.default.string,
  receiveSuggestions: _propTypes2.default.func,
  className: _propTypes2.default.string,
  placeholder: _propTypes2.default.any,
  searchAddress: _propTypes2.default.func,
  address: _propTypes2.default.array,
  isBrokerCommunity: _propTypes2.default.bool,
  isRealtorsAssociation: _propTypes2.default.bool,
  queryName: _propTypes2.default.string,
  query: _propTypes2.default.object };exports.default =


ProfessionalsPageSearchInput;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProfessionalsPageSearchInput/ProfessionalsPageSearchInput.js
// module id = 2820
// module chunks = 0